export const dataDefault = [
    {
        "name": "Jan",
        "sort": 0,
        "month_status": "Budget",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jan",
        "sort": 1,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jan",
        "sort": 2,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Feb",
        "sort": 3,
        "month_status": "Budget",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Feb",
        "sort": 4,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Feb",
        "sort": 5,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Mar",
        "sort": 6,
        "month_status": "Budget",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Mar",
        "sort": 7,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Mar",
        "sort": 8,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Apr",
        "sort": 9,
        "month_status": "Budget",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Apr",
        "sort": 10,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Apr",
        "sort": 11,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "May",
        "sort": 12,
        "month_status": "Budget",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "May",
        "sort": 13,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "May",
        "sort": 14,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jun",
        "sort": 15,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jun",
        "sort": 16,
        "month_status": "Actual",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jun",
        "sort": 17,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jul",
        "sort": 18,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jul",
        "sort": 19,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Jul",
        "sort": 20,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Aug",
        "sort": 21,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Aug",
        "sort": 22,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Aug",
        "sort": 23,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Sep",
        "sort": 24,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Sep",
        "sort": 25,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Sep",
        "sort": 26,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Oct",
        "sort": 27,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Oct",
        "sort": 28,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Oct",
        "sort": 29,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Nov",
        "sort": 30,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Nov",
        "sort": 31,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Nov",
        "sort": 32,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Dec",
        "sort": 33,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Dec",
        "sort": 34,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Dec",
        "sort": 35,
        "month_status": "Actual Last Year",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "YTD",
        "sort": 36,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "YTD",
        "sort": 37,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "YTD",
        "sort": 38,
        "month_status": "Variance%",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Year End",
        "sort": 39,
        "month_status": "",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Year End",
        "sort": 40,
        "month_status": "Act/Fcst ",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
    {
        "name": "Year End",
        "sort": 41,
        "month_status": "Variance%",
        wedding_covers: 0,
        wedding_ac: 0,
        wedding_rev: 0,
        wedding_room: 0,
        wedding_other: 0,
        wedding_total: 0,
        wedding_proportion: 0,
        social_covers: 0,
        social_ac: 0,
        social_rev: 0,
        social_room: 0,
        social_other: 0,
        social_total: 0,
        social_proportion: 0,
        group_covers: 0,
        group_ac: 0,
        group_rev: 0,
        group_room: 0,
        group_other: 0,
        group_total: 0,
        group_proportion: 0,
        grand_covers: 0,
        grand_ac: 0,
        grand_rev: 0,
        grand_room: 0,
        grand_other: 0,
        grand_total: 0,
    },
]


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-1/6.1.1/data.js